import React from 'react'

import Layout from '../components/layout'

const About = ({location}) => (
  <Layout location={location}>
    <div>
      <h1>About Me</h1>
      <p>This is the about me page</p>
    </div>
  </Layout>
)

export default About
